import { render, staticRenderFns } from "./SurveyFormTemplate.vue?vue&type=template&id=8c24c1ac&scoped=true"
import script from "./SurveyFormTemplate.vue?vue&type=script&lang=js"
export * from "./SurveyFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c24c1ac",
  null
  
)

export default component.exports